/* unplugin-vue-components disabled */import script from "./Flag.vue?vue&type=script&lang=ts&setup=true"
export * from "./Flag.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__